import dimmedDisabled from "@mittwald/flow-styles/dist/mixins/dimmedDisabled";
import { color, spacing } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled, { css } from "styled-components";
import { px } from "../../../mixins/formatters";
import { Bobbale } from "../../Bobbale/styled";
import { EdgeToEdgeContent } from "../../EdgeToEdgeContent";
import config from "../config";
export const RowStyle = css `
  height: ${px(config.rowHeight)};
  display: grid;
  align-items: center;
  grid-gap: ${spacing.base.xxl};

  &:is(.active) {
    background-color: ${color.background.selectableBox.selected};
    border-top: ${px(config.rowBorderSize)} solid;
    border-bottom: ${px(config.rowBorderSize)} solid;
    border-color: ${color.border.row.selected};
  }

  &:not(.disabled):hover {
    background: ${color.background.selectableBox.hovered};

    ${Bobbale} {
      border-color: ${color.background.selectableBox.hovered};
    }
  }

  &.disabled {
    background-color: ${color.background.light};
  }

  &.disabled {
    .imageBox,
    .bodyColumns,
    .nameColumn,
    .nameCol,
    .iconOnly {
      ${dimmedDisabled};
      cursor: default;
    }

    ${Bobbale} {
      border-color: ${color.background.light};
    }
  }

  &.disabled {
    .secondaryActions,
    .bodyColumns {
      pointer-events: none;
    }
  }
`;
export const Row = styled(EdgeToEdgeContent) `
  ${RowStyle}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUm93LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUmVzb3VyY2VMaXN0L3N0eWxlZC9Sb3cudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxjQUFjLE1BQU0sa0RBQWtELENBQUM7QUFDOUUsT0FBTyxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUNoRixPQUFPLE1BQU0sRUFBRSxFQUFFLEdBQUcsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ2hELE9BQU8sRUFBRSxFQUFFLEVBQUUsTUFBTSw0QkFBNEIsQ0FBQztBQUNoRCxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFDL0MsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0seUJBQXlCLENBQUM7QUFFNUQsT0FBTyxNQUFNLE1BQU0sV0FBVyxDQUFDO0FBRS9CLE1BQU0sQ0FBQyxNQUFNLFFBQVEsR0FBRyxHQUFHLENBQUE7WUFDZixFQUFFLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBQzs7O2NBR2xCLE9BQU8sQ0FBQyxJQUFJLENBQUMsR0FBRzs7O3dCQUdOLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLFFBQVE7a0JBQzdDLEVBQUUsQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDO3FCQUNyQixFQUFFLENBQUMsTUFBTSxDQUFDLGFBQWEsQ0FBQztvQkFDekIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsUUFBUTs7OztrQkFJM0IsS0FBSyxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsT0FBTzs7TUFFbEQsT0FBTztzQkFDUyxLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxPQUFPOzs7Ozt3QkFLcEMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLOzs7Ozs7Ozs7UUFTdEMsY0FBYzs7OztNQUloQixPQUFPO3NCQUNTLEtBQUssQ0FBQyxVQUFVLENBQUMsS0FBSzs7Ozs7Ozs7OztDQVUzQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sR0FBRyxHQUFHLE1BQU0sQ0FBQyxpQkFBaUIsQ0FBQyxDQUFBO0lBQ3hDLFFBQVE7Q0FDWCxDQUFDIn0=